import React, { useMemo, type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import type { Message as MessageType } from '../../../common/types';
import { useIsLastMessage } from '../../../controllers/conversation-store';
import type { messageRendererHelpseeker$key } from './__generated__/messageRendererHelpseeker.graphql';
import { AgentMessage } from './agent-message';
import { ErrorMessage } from './error-message';
import { HelpseekerMessage } from './helpseeker-message';

export const MessageRenderer: FC<{
    userRef: messageRendererHelpseeker$key | undefined | null;
    messageResponse: MessageType;
}> = ({ userRef, messageResponse }) => {
    const isLastMessage = useIsLastMessage(messageResponse.id);

    const data = useFragment<messageRendererHelpseeker$key>(
        graphql`
            fragment messageRendererHelpseeker on User {
                ...helpseekerMessage
            }
        `,
        userRef
    );

    const ErrorMessageMemo = useMemo(() => <ErrorMessage hasRetryAction={isLastMessage} />, [isLastMessage]);

    switch (messageResponse.message.authorType) {
        case 'AGENT':
            return <AgentMessage message={messageResponse.message} isLastMessage={isLastMessage} />;
        case 'HELPSEEKER':
            return <HelpseekerMessage userRef={data} messageContent={messageResponse.message.content} />;
        case 'ERROR':
            return ErrorMessageMemo;
        default:
            return null;
    }
};
